module.exports = "https://coursera_assets.s3.amazonaws.com/images/2e4978d38e71f237eceed9170c10a6f9.png";